import { useState, useEffect } from 'react';

import { getS3DownloadLink } from '~/clients/jsonApi';

function useSignedURL(fileName, contentDisposition = 'attachment') {
  const [signedURL, setSignedURL] = useState('');

  useEffect(() => {
    if (fileName) {
      getS3DownloadLink(fileName, contentDisposition)
        .then(response => {
          setSignedURL(response.url);
        })
        .catch(error => {
          console.error(error);
          setSignedURL('');
        });
    }
  }, [fileName, contentDisposition]);

  return signedURL;
}

export default useSignedURL;
